import { put } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "../messages";

function* startUserProjectsReport(action) {
  const params = {
    report_type: "user_projects_report",
    ...action.payload,
  };
  const { success, data, error } = yield* makeRequest.post("/reports", params);
  if (success && data) {
    yield put(actions.setUserProjectsReport(data.body));
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_STARTING_USER_PROJECTS_REPORT,
    });
  }
  return null;
}

export default startUserProjectsReport;
